import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from '../../../../commons/useTranslasion';

const ProgramaResumo = ({ programa }: any) => {
  const { translate } = useTranslation();

  return (
    <Box sx={{ marginBottom: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{translate("nome")}</TableCell>
            <TableCell>{translate("programa")}</TableCell>
            <TableCell>{translate("prazo")}</TableCell>
            <TableCell>{translate("inicio")}</TableCell>
            <TableCell>{translate("termino")}</TableCell>
            <TableCell>{translate("ultimoCargo")}</TableCell>
            <TableCell>{translate("status")}</TableCell>
            <TableCell>{translate("responsavel")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{programa.nome}</TableCell>
            <TableCell>{programa.programa}</TableCell>
            <TableCell>{programa.prazo}</TableCell>
            <TableCell>{programa.inicio}</TableCell>
            <TableCell>{programa.termino}</TableCell>
            <TableCell>{programa.cargo}</TableCell>
            <TableCell>{programa.status}</TableCell>
            <TableCell>{programa.responsavel}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default ProgramaResumo;
